// <!-- ============================================================================= -->
// <!-- Ella Custom JS - Customize The Style For Layout -->
// <!-- ============================================================================= -->

// <!-- ============================================================================= -->
// <!-- IMPORTANT DISCLAIMER -->
// <!-- Please use only JS to style the layout. -->
// <!-- ============================================================================= -->

// class ReviewSlider extends HTMLElement {
//   constructor() {
//     super();
//     const slideEle = this.querySelector('.review-slider');    
//     let slider = new Swiper(slideEle, {
//       slidesPerView: 1,
//       loop: true,
//       dots: true,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       spaceBetween: 0,        
//     });
//   }

//   connectedCallback() {    
    
//   }  
  
// }
// customElements.define('review-slider', ReviewSlider);


class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    const slideEle = this.querySelector('.review-slider');
    const paginationEl = this.querySelector('.swiper-pagination');
    const nextBtn = this.querySelector('.swiper-button-next');
    const prevBtn = this.querySelector('.swiper-button-prev');

    new Swiper(slideEle, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }

  connectedCallback() {}
}

customElements.define('review-slider', ReviewSlider);

// function showBadge() {
//   const variant = document.querySelectorAll('.meta_connected_prd');
//     variant.forEach(elt => {
//       const prod_badge = elt.querySelector('.prod_badge');
//     const prod_var_wt = elt.querySelector('.prod_var_price').textContent; 
//     console.log("Variant weight: ", prod_var_wt);

//     if (prod_var_wt == '100g') {
//       console.log("Badge: ", prod_badge);
//       prod_badge.style.display = 'flex';
//     }
//   })
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const variants = document.querySelectorAll('.meta_connected_prd');
  
//   variants.forEach(variant => {
//     const prod_var_price = parseInt(variant.querySelector('.prod_var_price').textContent.trim()); 
//     console.log("Wt :",  prod_var_price);
       
//     const prod_price = variant.querySelector('.prod_price_gram');
//     const prod_ac_price = parseInt(variant.querySelector('.prod_ac_price').textContent.trim() / 100);
//     const price_per_gr = prod_ac_price / prod_var_price;
    
//     prod_price.textContent = `$${price_per_gr.toFixed(2)} / g`;
//   });

//   showBadge();
// });
